export default __webpack_public_path__ + "static/media/03.fd772691.jpg";